'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserJobEditController = function () {
  function UserJobEditController(JobsService, $scope, $window) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserJobEditController);
    this.JobsService = JobsService;
    this.$scope = $scope;
    this.$window = $window;
  }

  (0, _createClass3.default)(UserJobEditController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);

      dataSource.bind('requestEnd', function (e) {
        if (e.type === 'update' && e.response) {
          _this.$scope.$applyAsync();
          _this.$window.location.reload();
        }
      });

      this.gridOptions = {
        dataSource: dataSource,
        sortable: true,
        pageable: true,
        resizable: true,
        editable: 'inline',
        noRecords: {
          template: 'No Jobs found.'
        },
        columns: [{ field: 'id', title: 'ID', width: '2rem', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' }, { field: 'paymentType', title: 'Payment Type', width: '4rem', filterable: false, template: '#= data.paymentType || data.PaymentType || "" #' }, { field: 'jobDate', title: 'Job Date', width: '3.5rem', filterable: false, template: '#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), \'dd/MM/yyyy\') : "" #' }, { field: 'estimatedJobHours', title: 'Est. Hours', width: '3rem', filterable: false, template: '#= data.estimatedJobHours || data.EstimatedJobHours || "" #' }, { field: 'price', title: 'Price', width: '3rem', filterable: false, template: '#= data.price || data.Price || 0 #' }, { field: 'overtimeRate', title: 'Overtime Rate', width: '3.5rem', filterable: false, template: '#= data.overtimeRate || data.OvertimeRate || 0 #' }, { field: 'estimatedJobValue', title: 'Est. Value', width: '3rem', filterable: false, template: '#= data.estimatedJobValue || data.EstimatedJobValue || 0 #' }, { command: ['edit'], title: 'Actions', width: '3.5rem' }]
      };
    }
  }]);
  return UserJobEditController;
}();

exports.default = UserJobEditController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-job-edit/user-job-edit.controller.js
 **/